import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
  Link as MuiLink,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

const navItems = [
  { label: "Sobre", href: "#about" },
  { label: "Serviços", href: "#services" },
  { label: "Contato", href: "#contact" },
];

export const Navbar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center", pt: 2 }}>
      <Typography
        variant="h6"
        sx={{ my: 2, color: theme.palette.text.primary }}
      >
        Menu
      </Typography>
      <List>
        {navItems.map((item) => (
          <ListItem button key={item.label} component="a" href={item.href}>
            <ListItemText
              primary={item.label}
              sx={{ color: theme.palette.text.primary }}
            />
          </ListItem>
        ))}
      </List>
      <Button variant="contained" color="secondary" sx={{ mt: 2 }}>
        Comece Agora
      </Button>
    </Box>
  );

  return (
    <AppBar position="sticky" elevation={0}>
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ justifyContent: "space-between" }}>
          <Typography
            variant="h6"
            component="a"
            href="/"
            sx={{
              fontWeight: 700,
              color: "inherit",
              textDecoration: "none",
            }}
          >
            Logo/Nome
          </Typography>

          {isMobile ? (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="end"
              onClick={handleDrawerToggle}
            >
              <MenuIcon />
            </IconButton>
          ) : (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {navItems.map((item) => (
                <MuiLink
                  key={item.label}
                  href={item.href}
                  sx={{
                    mx: 1.5,
                    color: theme.palette.text.secondary,
                    fontWeight: 500,
                    "&:hover": {
                      color: theme.palette.primary.main,
                      textDecoration: "none",
                    },
                  }}
                >
                  {item.label}
                </MuiLink>
              ))}
              <Button
                variant="contained"
                color="secondary"
                sx={{ ml: 2 }}
                href="#cta"
              >
                Comece Agora
              </Button>
            </Box>
          )}
        </Toolbar>
      </Container>
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        anchor="right"
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: 240,
            backgroundColor: theme.palette.background.paper, // Fundo do drawer
          },
        }}
      >
        {drawer}
      </Drawer>
    </AppBar>
  );
};
